
import { CSSProperties } from "@mui/material";

export const InputSearchStyle  : CSSProperties = {
    padding: '11px 1px', 
    display: 'flex', 
    alignItems: 'center', 
    width: '100%', 
    boxShadow: 'none', 
    border: '1px solid rgba(0, 0, 0, 0.2)',
}

export const InputSearchButtonsStyle  : CSSProperties = {
    borderRadius: 10, 
    marginRight: 1
}